var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0.5C22.6569 0.5 24 1.84315 24 3.5V14C24 15.6569 22.6569 17 21 17H3C1.34315 17 0 15.6569 0 14V3.5C0 1.84315 1.34315 0.5 3 0.5H21ZM21 2H3C2.23075 2 1.59674 2.57906 1.51009 3.32507L1.5 3.5V14C1.5 14.7693 2.07906 15.4033 2.82507 15.4899L3 15.5H21C21.7693 15.5 22.4033 14.9209 22.4899 14.1749L22.5 14V3.5C22.5 2.73075 21.9209 2.09674 21.1749 2.01009L21 2ZM20.25 12.5C20.6642 12.5 21 12.8358 21 13.25C21 13.6642 20.6642 14 20.25 14H3.75C3.33579 14 3 13.6642 3 13.25C3 12.8358 3.33579 12.5 3.75 12.5H20.25ZM20.25 9.5C20.6642 9.5 21 9.83579 21 10.25C21 10.6642 20.6642 11 20.25 11H3.75C3.33579 11 3 10.6642 3 10.25C3 9.83579 3.33579 9.5 3.75 9.5H20.25ZM9.75 6.5C10.1642 6.5 10.5 6.83579 10.5 7.25C10.5 7.66421 10.1642 8 9.75 8H3.75C3.33579 8 3 7.66421 3 7.25C3 6.83579 3.33579 6.5 3.75 6.5H9.75ZM14.25 3.5C14.6642 3.5 15 3.83579 15 4.25C15 4.66421 14.6642 5 14.25 5H3.75C3.33579 5 3 4.66421 3 4.25C3 3.83579 3.33579 3.5 3.75 3.5H14.25Z",
    fill: "#0B3A5F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdBack);
export default __webpack_public_path__ + "static/media/id-back.7b696e495f13742a583a079931b7aaa4.svg";
export { ForwardRef as ReactComponent };